export default __webpack_public_path__ + "static/media/moon.3bea3d39.png";